import { createSlice } from '@reduxjs/toolkit';
import {
  deleteMedication,
  fetchMedications,
  insertMedications,
  searchMedications,
  updateMedication,
} from './actions';
import { Medication, MedicationSearchResult } from './models';

export interface MedicationState {
  medications: Medication[];
  loadingMedications: boolean;
  loadingInsertMedications: boolean;
  medicationSearchResults: MedicationSearchResult[];
  loadingSearchMedications: boolean;
}

const initialState: MedicationState = {
  medications: [],
  loadingMedications: false,
  loadingInsertMedications: false,
  medicationSearchResults: [],
  loadingSearchMedications: false,
};

const medicationSlice = createSlice({
  name: 'medication',
  initialState,
  reducers: {
    clearMedicationSearchResults: (state) => {
      state.medicationSearchResults = [];
    },
    clearMedications: (state) => {
      state.loadingMedications = true;
      state.medications = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMedications.pending, (state) => {
        state.loadingMedications = true;
      })
      .addCase(fetchMedications.fulfilled, (state, action) => {
        state.medications = action.payload;
        state.loadingMedications = false;
      })
      .addCase(fetchMedications.rejected, (state) => {
        state.loadingMedications = false;
      })
      .addCase(searchMedications.pending, (state) => {
        state.loadingSearchMedications = true;
      })
      .addCase(searchMedications.fulfilled, (state, action) => {
        state.medicationSearchResults = action.payload;
        state.loadingSearchMedications = false;
      })
      .addCase(searchMedications.rejected, (state) => {
        state.medicationSearchResults = [];
        state.loadingSearchMedications = false;
      })
      .addCase(insertMedications.fulfilled, (state) => {
        state.loadingInsertMedications = false;
      })
      .addCase(insertMedications.pending, (state) => {
        state.loadingInsertMedications = true;
      })
      .addCase(insertMedications.rejected, (state) => {
        state.loadingInsertMedications = false;
      })
      .addCase(updateMedication.fulfilled, (state, action) => {
        const updatedMedications = state.medications.map((medication) =>
          medication.id === action.payload.id ? action.payload : medication
        );
        state.medications = updatedMedications;
      })
      .addCase(deleteMedication.fulfilled, (state, action) => {
        state.medications = state.medications.filter(
          (medication) => medication.id !== action.meta.arg
        );
      });
  },
});

export const { clearMedicationSearchResults, clearMedications } =
  medicationSlice.actions;

export default medicationSlice.reducer;
